export default "__VITE_ASSET__YNpbSyFJ__"